import { Box, Step, StepLabel, Stepper, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { useOnUnmount } from '@/hooks/useOnUnmount';
import useQuoteIntakeSetupStore from '@/stores/useQuoteIntakeSetupStore';
import { errorSnackbar } from '@/utils/snackbar';
import QuoteIntakeSetup from './QuoteIntakeSetup';
import QuoteIntakeSetupFooter from './QuoteIntakeSetup/QuoteIntakeSetupFooter';

export default function QuoteIntake() {
    const theme = useTheme();
    const [currentStep, error, resetSetupState] = useQuoteIntakeSetupStore((state) => [
        state.currentStep,
        state.error,
        state.resetSetupState,
    ]);

    useOnUnmount(resetSetupState);

    useEffect(() => {
        if (error) {
            errorSnackbar(error);
        }
    }, [error]);

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateRows: '96px 1fr 72px',
                height: '100vh',
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    alignItems: 'center',
                    height: '100%',
                    width: '100%',
                    boxSizing: 'border-box',
                    backgroundColor: '#FFFFFF',
                    boxShadow: theme.customShadows.modal,
                    borderBottom: `1px solid ${theme.palette.neutral.borderColor}`,
                }}
            >
                <Stepper activeStep={currentStep} alternativeLabel>
                    <Step>
                        <StepLabel>Matter type</StepLabel>
                    </Step>
                    <Step>
                        <StepLabel>Quote design</StepLabel>
                    </Step>
                    <Step>
                        <StepLabel>Quote email</StepLabel>
                    </Step>
                    <Step>
                        <StepLabel>Fee details</StepLabel>
                    </Step>
                    <Step>
                        <StepLabel>Intake design</StepLabel>
                    </Step>
                    <Step>
                        <StepLabel>Intake email</StepLabel>
                    </Step>
                </Stepper>
            </Box>
            <QuoteIntakeSetup />
            <QuoteIntakeSetupFooter />
        </Box>
    );
}
